import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { FeedInterface } from 'app/models/feed.model';
import { RequestService } from 'app/modules/common/utils/request.service';
import { Observable } from 'rxjs';
import { FeedDataTransformPost } from './data-transforms/feed.data.transform.post';
import { FeedDataTransformGet } from './data-transforms/feed.data.transform.get';

@Injectable({
  providedIn: 'root',
})
export class FeedHttpInterceptor implements HttpInterceptor {
  private readonly _rexp = new RegExp(/^\/feeds(\/[0-9a-z]{24})?$/);

  constructor(
    private readonly _transformUp: FeedDataTransformGet,
    private readonly _transformDown: FeedDataTransformPost,
  ) {}

  intercept(req: HttpRequest<FeedInterface>, next: HttpHandler): Observable<HttpEvent<FeedInterface>> {
    return RequestService.getTransformedHttpEvent<FeedInterface>(
      req,
      next,
      this._rexp,
      this._transformDown,
      this._transformUp,
    );
  }
}
